import React, { useState, useContext, useEffect } from "react"
import { Redirect } from "react-router"
import { AuthContext } from "../../Auth.js"
import { Message } from 'semantic-ui-react';
import EpicMenu from '../../componentes/Menus/EpicMenu';
import Datos from './datos';
import Payment from './payment';
import { getCompanyDocument } from '../../firebase';

function Ajustes () {
	const { currentUser } = useContext(AuthContext)
	const [loading, setLoading] = useState(true);
    const [nombre, setNombre] = useState('');
    const [almacenes, setAlmacenes] = useState([]);
    const [almPrincipal, setAlmaPrincipal] = useState([]);
    const [fechaContrato, setFechaContrato] = useState('');
    const [ultimoPago, setUltimoPago] = useState('');
    const [empMensual, setEmpMensual] = useState(0);
    const [empAnual, setEmpAnual] = useState(0);
    const [demo, setDemo] = useState(false);
	const [refreshCount, setRefreshCount] = useState(0);
	
	useEffect(() => {
		const fetchData = async () => {
		  try {
			const docRef = await getCompanyDocument();
			const doc = await docRef.get();
			if (doc.exists) {
			  const nombre = doc.data().name || '';
			  const almacenes = doc.data().almacenes
			  const almPrincipal = doc.data().almPrincipal
			  const fechaContrato = doc.data().fechaContrato
			  const ultimoPago = doc.data().ultimoPago
			  const empMensual = doc.data().empMensual || 0
			  const empAnual = doc.data().empAnual || 0
			  const demo = doc.data().demo
			  setNombre(nombre);
			  setUltimoPago(ultimoPago)
			  setAlmacenes(almacenes);
			  setAlmaPrincipal(almPrincipal);
			  setFechaContrato(fechaContrato)
			  setEmpMensual(empMensual)
			  setEmpAnual(empAnual)
			  setDemo(demo);
			  setLoading(false);
			} else {
			  console.log('Document not found');
			}
		  } catch (error) {
			console.error('Error fetching document:', error);
		  }
		};
		fetchData();
	}, [refreshCount]);

	const handleRefresh = () => {
		setRefreshCount(refreshCount + 1);
		console.log("refresh"+refreshCount)
	};

	if (currentUser.rol === 'admin') {
	  return (
		<div className='settingsPage'>
			<div className='header settingsHeader'>
				<EpicMenu />
				<div className='inline'>Configuración</div>
			</div>
			<main className='settingsContent'>
				<div className='settingsIntro'>
					<h1>Ajustes del rancho</h1>
					<p>Administra la información general, la capacidad de empleados y los datos de tu suscripción.</p>
				</div>
				{loading ? (
					<div className='settingsLoading'>Cargando configuración...</div>
				) : (
					<div className='settingsGrid'>
					<Datos
						onModalSubmit={handleRefresh}
						rol={currentUser.rol}
						nombre={nombre}
						almacenes={almacenes}
						almPrincipal={almPrincipal}
					/>
					{!demo ? (
						<Payment
							ultimoPago={ultimoPago}
							rol={currentUser.rol}
							onModalSubmit={handleRefresh}
							fechaContrato={fechaContrato}
							empMensual={empMensual}
							empAnual={empAnual}
						/>
					) : <Message>Está utilizando la versión de prueba.</Message>
						}
					</div>
				)}
			</main>
			<div className="footer" >
				<div className="footer1" ></div>
				<div className="footer2" ></div>
			</div>
		</div>
      )
	} else {
		return <Redirect to="/Pendientes" />
	}
}

export default Ajustes;
